import { useEffect } from 'react'

type HandledEvents = ['mousedown', 'touchstart']
type HandledEventsType = HandledEvents[number]
type PossibleEvent = {
  [Type in HandledEventsType]: HTMLElementEventMap[Type]
}[HandledEventsType]

export default function useOnClickOutside(ref, handler) {
  useEffect(() => {
    const listener = (event: PossibleEvent) => {
      const { target } = event

      if (!ref.current || ref.current.contains(target)) {
        return
      }
      if (
        (event as HTMLElementEventMap['mousedown']).clientX >=
        (target as HTMLElement).clientWidth
      ) {
        // user clicked on a scrollbar of the target element
        return
      }
      handler(event)
    }

    document.addEventListener('mousedown', listener)
    document.addEventListener('touchstart', listener)

    return () => {
      document.removeEventListener('mousedown', listener)
      document.removeEventListener('touchstart', listener)
    }
  }, [ref, handler])
}
